<template>
  <div>
    <div class="card top-draft">
      <div class="card-body">
        <!-- <div class="col-lg-12 mg-top-1">
          <b-button variant="primary" @click="toCreate()">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            添加
          </b-button>
        </div> -->

        <div class="col-lg-12 list-header mg-top-1 pad-header-bg clearfix">
          <b-button
            class="pull-left"
            size="sm"
            variant="primary"
            @click="submitExport()"
          >
            <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
            全部导出
          </b-button>

          <div class="header-item-fix">
            <b-form-input
              size="sm"
              type="text"
              v-model="pageParams.contentKeyword"
              placeholder="请输入搜索内容"
            ></b-form-input>
            <b-button size="sm" variant="primary" @click="search()">
              <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
              搜索
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="resetParams()"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              重置
            </b-button>
          </div>

          <div class="header-item-fix app-search-header-item">
            <span style="padding-top: 5px;">领取时间：</span>
            <date-picker
              v-model="countTime"
              type="datetime"
              placeholder="开始时间 - 结束时间"
              range
              append-to-body
              lang="en"
              confirm
            ></date-picker>
          </div>

          <div class="header-item-fix app-search-header-item">
            <span style="padding-top: 5px;">核销时间：</span>
            <date-picker
              v-model="receiveTime"
              type="datetime"
              placeholder="开始时间 - 结束时间"
              range
              append-to-body
              lang="en"
              confirm
            ></date-picker>
          </div>

          <div class="header-item-fix">
            <b-form-select
              @change="search()"
              v-model="pageParams.couponType"
              class="form-select"
              :options="types"
              type="text"
            ></b-form-select>
          </div>

          <!-- <div class="header-item-fix">
            <b-form-select
              @change="search()"
              v-model="pageParams.showState"
              class="form-select"
              :options="statusList"
              type="text"
            ></b-form-select>
          </div> -->
        </div>

        <div class="col-lg-12">
          <div class="table-responsive">
            <table
              class="table project-list-table table-nowrap table-centered table-borderless align-middle table-hover"
            >
              <thead>
                <tr>
                  <th scope="col" style="width: 70px;">ID</th>
                  <th scope="col">优惠码</th>
                  <th scope="col">类型</th>
                  <th scope="col">所属商家</th>
                  <th scope="col">用户昵称</th>
                  <th scope="col">手机号码</th>
                  <th scope="col">核销门店</th>
                  <th scope="col">核销人</th>
                  <th scope="col">备注</th>
                  <th scope="col">领取日期</th>
                  <th scope="col">核销日期</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>{{ item.id }}</td>
                  <td>{{ item.code }}</td>
                  <td>
                    {{
                      item.couponType == 1
                        ? "代金券"
                        : item.couponType == 2
                        ? "折扣券"
                        : item.couponType == 3
                        ? "通用券"
                        : "--"
                    }}
                  </td>
                  <td>{{ item.merchant ? item.merchant.name : "--" }}</td>
                  <td>{{ item.member ? item.member.nickname : "--" }}</td>
                  <td>{{ item.member ? item.member.phone : "--" }}</td>
                  <td>{{ item.store || "--" }}</td>
                  <td>{{ item.verifier || "--" }}</td>
                  <td>{{ item.remark || "--" }}</td>
                  <td>{{ item.createdAt || "--" }}</td>
                  <td>{{ item.verifiedAt || "--" }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <pagination ref="page" @pageCallback="pageCallback"></pagination>
        </div>
        <app-list-loading ref="loading"></app-list-loading>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import pagination from "@/components/pagination/pagination.vue";
import conpon from "../../../../server/api/coupons";
import DatePicker from "vue2-datepicker";

/**
 * Contacts-list component
 */
export default {
  components: {
    pagination,
    DatePicker,
  },

  props: {
    tagList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  data() {
    return {
      choiceListIds: [], //当前所选择的id
      allListIds: [],
      indeterminate: false, //全选
      pageParams: {
        page: 1,
        pageSize: 30,
        showState: "",
        contentKeyword: "",
        couponType: "",
      },
      items: [],
      statusList: [
        { text: "状态筛选", value: "" },
        { text: "上架", value: "1" },
        { text: "下架", value: "0" },
      ],
      types: [
        { text: "筛选类型", value: "" },
        { text: "代金券", value: "1" },
        { text: "折扣券", value: "2" },
        { text: "通用券", value: "3" },
      ],
      receiveTime: "",
      countTime: "",
    };
  },

  watch: {
    choiceListIds: function() {
      if (
        this.choiceListIds.length == this.allListIds.length &&
        this.choiceListIds.length > 0
      ) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
  },

  mounted() {
    this.getList();
  },

  created() {},

  methods: {
    //获取列表数据
    getList() {
      var xhr = new XMLHttpRequest();
      var formData = new FormData();

      let url =
        env.API_HOST +
        "/create-platform/coupon/codes/merchant/verified?merchantId=" +
        JSON.parse(localStorage.chosedMedia).id;

      if (this.pageParams.contentKeyword) {
        url = url + "&q%5Bkeywords%5D=" + this.pageParams.contentKeyword;
      }

      if (this.pageParams.couponType) {
        url = url + "&q%5Btype%5D=" + this.pageParams.couponType;
      }

      if (this.receiveTime[0]) {
        // url = url + "&q%5Bv_start_time%5D=" + this.receiveTime[0].format("yyyy-MM-dd hh:mm:ss")
        // url = url + "&q%5Bv_end_time%5D=" + this.receiveTime[1].format("yyyy-MM-dd hh:mm:ss")
        url =
          url + "&q%5Bv_start_time%5D=" + this.receiveTime[0].getTime() / 1000;
        url =
          url + "&q%5Bv_end_time%5D=" + this.receiveTime[1].getTime() / 1000;
      }
      if (this.countTime[0]) {
        // url = url + "&q%5Br_start_time%5D=" + this.countTime[0].format("yyyy-MM-dd hh:mm:ss")
        // url = url + "&q%5Br_end_time%5D=" + this.countTime[1].format("yyyy-MM-dd hh:mm:ss")
        url =
          url + "&q%5Br_start_time%5D=" + this.countTime[0].getTime() / 1000;
        url = url + "&q%5Br_end_time%5D=" + this.countTime[1].getTime() / 1000;
      }

      this.$refs.loading.show();
      this.items = [];
      let that = this;

      xhr.open("get", url);
      xhr.setRequestHeader("x-auth-token", this.cookies.getCookie("token"));
      // xhr.responseType = 'blob';
      xhr.onload = function(e, resp) {
        if (this.status == 200) {
          var resp = JSON.parse(this.responseText);
          if (resp.code == 0) {
            if (that.$refs.loading) {
              that.$refs.loading.hide(resp.data.items);
            }
            if (resp.data.items) {
              let ids = [];
              resp.data.items.map((item) => {
                ids.push(item.id);
                if (item.createdAt) {
                  item.createdAt = that.utils.getTimeStamp(item.createdAt);
                }
                if (item.verifiedAt) {
                  item.verifiedAt = that.utils.getTimeStamp(item.verifiedAt);
                }
              });
              that.choiceListIds = [];
              that.allListIds = ids; //当前列表全部id
              that.items = resp.data.items;
              let pages = {
                page: resp.data.page, //第几页
                pageSize: resp.data.pageSize, //每页多少条
                total: resp.data.total, //全部有多少条数据
                totalPages: resp.data.totalPages, //全部有几页
              };
              that.$nextTick(() => {
                if (that.$refs.page) {
                  that.$refs.page.setPages(pages);
                }
              });
            }
          } else {
            if (that.$refs.loading) {
              that.$refs.loading.hide();
            }
          }
        }
      };
      xhr.send(formData);
    },

    submitExport() {
      function createObjectURL(object) {
        return window.URL
          ? window.URL.createObjectURL(object)
          : window.webkitURL.createObjectURL(object);
      }
      var xhr = new XMLHttpRequest();
      var formData = new FormData();

      let url =
        env.API_HOST +
        "/create-platform/coupon/codes/verified/export?merchantId=" +
        JSON.parse(localStorage.chosedMedia).id;

      if (this.pageParams.contentKeyword) {
        url = url + "&q%5Bkeywords%5D=" + this.pageParams.contentKeyword;
      }

      if (this.pageParams.couponType) {
        url = url + "&q%5Btype%5D=" + this.pageParams.couponType;
      }

      if (this.receiveTime[0]) {
        // url = url + "&q%5Bv_start_time%5D=" + this.receiveTime[0].format("yyyy-MM-dd hh:mm:ss")
        // url = url + "&q%5Bv_end_time%5D=" + this.receiveTime[1].format("yyyy-MM-dd hh:mm:ss")
        url =
          url + "&q%5Bv_start_time%5D=" + this.receiveTime[0].getTime() / 1000;
        url =
          url + "&q%5Bv_end_time%5D=" + this.receiveTime[1].getTime() / 1000;
      }
      if (this.countTime[0]) {
        // url = url + "&q%5Br_start_time%5D=" + this.countTime[0].format("yyyy-MM-dd hh:mm:ss")
        // url = url + "&q%5Br_end_time%5D=" + this.countTime[1].format("yyyy-MM-dd hh:mm:ss")
        url =
          url + "&q%5Br_start_time%5D=" + this.countTime[0].getTime() / 1000;
        url = url + "&q%5Br_end_time%5D=" + this.countTime[1].getTime() / 1000;
      }

      xhr.open("get", url);
      xhr.setRequestHeader("x-auth-token", this.cookies.getCookie("token"));
      xhr.responseType = "blob";
      xhr.onload = function(e) {
        if (this.status == 200) {
          var blob = this.response;
          var filename = "核销列表.xlsx";
          console.log(this.response);
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename);
          } else {
            var a = document.createElement("a");
            var url = createObjectURL(blob);
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }
      };
      xhr.send(formData);
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
      if (obj.code === "batch") {
        //处理批量操作
        if (obj.batch == 1) {
          if (this.choiceListIds.length) {
            //点击显示的处理方法
            this.batchShow();
          } else {
            Vue.swal("请选择要显示的内容");
            return;
          }
        }
        if (obj.batch == 2) {
          if (this.choiceListIds.length) {
            //点击隐藏的处理方法
            this.batchHide();
          } else {
            Vue.swal("请选择要隐藏的内容");
            return;
          }
        }
        if (obj.batch == 3) {
          if (this.choiceListIds.length) {
            //点击移除的处理方法
            this.remove();
          } else {
            Vue.swal("请选择要删除的内容");
            return;
          }
        }
      }
    },

    //添加
    toCreate() {
      this.$router.push({
        name: "couponDetail",
      });
    },

    //去编辑
    toDetail(item, allModify) {
      if (allModify) {
        this.$router.push({
          name: "couponDetail",
          query: { id: item.id, allModify: true },
        });
      } else {
        this.$router.push({
          name: "couponDetail",
          query: { id: item.id },
        });
      }
    },

    openReject(item) {
      Swal.fire({
        title: "驳回原因",
        text: item.taboo,
        confirmButtonColor: "#556ee6",
      });
    },

    //搜索
    search() {
      this.pageParams.page = 1;
      this.getList();
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.showState = "";
      this.pageParams.contentKeyword = "";
      this.pageParams.couponType = "";
      this.receiveTime = "";
      this.countTime = "";
      this.getList();
    },

    // 列表全选
    checkedAll() {
      if (this.indeterminate) {
        this.choiceListIds = this.allListIds;
      } else {
        this.choiceListIds = [];
      }
    },

    batchHide() {
      Swal.fire({
        title: "确定隐藏?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "隐藏",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          params.ids = this.choiceListIds;
          conpon.hideRecommend(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "隐藏成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getList();
            }
          });
        }
      });
    },

    batchShow() {
      Swal.fire({
        title: "确定显示?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "显示",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          params.ids = this.choiceListIds;
          conpon.showRecommend(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "显示成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getList();
            }
          });
        }
      });
    },

    batchExamine(item) {
      Swal.fire({
        title: "确定提交审核?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "提交",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          conpon.examine(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "提交成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getList();
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },

    batchRevert(item) {
      Swal.fire({
        title: "确定撤销?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "撤销",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          conpon.revert(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "撤销成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getList();
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },

    remove(item) {
      Swal.fire({
        title: "确定删除?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          conpon.remove(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "删除成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>

<style>
.app-search-header-item .mx-datepicker {
  width: 325px !important;
}

.app-search-header-item .mx-datepicker .mx-input {
  height: calc(1.5em + 0.41rem + 2px) !important;
  padding: 0.25rem 0.5rem;
  font-size: 0.8109375rem;
  border-radius: 0.2rem;
  outline: none;
}
</style>
